import styled, { css } from 'styled-components';
import { Btn } from 'components';

export const StatusInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 20px;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 0;
`;

export const ImgaeWrapper = styled.div`
    margin-bottom: 24px;
`;

export const SubTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 0;
`;

export const ChildrenWrapper = styled.div`
`;

interface BtnWrapperProps {
    btnWidth?: number;
}

export const BtnWrapper = styled.div<BtnWrapperProps>`
    width: ${props => props.btnWidth ? css`${props.btnWidth}px;` : css`100%;`}
`;

export const BtnHomeWrapper = styled.div`
    width: 170px;

`;

export const BtnHome = styled(Btn)`
    text-decoration-line: underline;
`;

